import React from 'react';
import { Box, Typography } from '@mui/material';
import { iconInfoSectionStyles } from './IconInfoSection.styles';

const IconInfoSection = ({ icon, title, subtitle }) => {
  const styles = iconInfoSectionStyles();

  // Check if icon is a string (image path) or a React component
  const isImagePath = typeof icon === 'string';

  return (
    <Box sx={styles.container} py={{xs: 2, lg: 0}} px={{xs: 2, lg: 0}}>
      <Box sx={styles.iconContainer}>
        {isImagePath ? (
          <Box
            component="img"
            src={icon}
            alt={title}
            loading="lazy"
            sx={styles.icon}
          />
        ) : (
          <Box sx={styles.icon}>
            {icon}
          </Box>
        )}
      </Box>
      <Box sx={styles.textContainer}>
        <Typography sx={styles.title}>{title}</Typography>
        <Typography sx={styles.subtitle}>{subtitle}</Typography>
      </Box>
    </Box>
  );
};

export default IconInfoSection;

